import { type RemoveHookResponse, mutationRemove } from '../hooks'
import { useLocationCache } from '../location'
import { useTantalimMutation } from '../mutation'
import { type OnLocationMutate } from './types'
import {
  Logger,
  toResponseError,
  type LocationId,
  type LocationNoteDeleteInput,
  type LocationNoteDeleteSuccess,
} from '@terros/common'

const logger = new Logger('note')

export function useDeleteLocationNote(
  onMutate: OnLocationMutate,
  locationId: LocationId
): RemoveHookResponse<LocationNoteDeleteInput> {
  logger.verbose('calling useRemoveLocationNote')
  const { replaceItem } = useLocationCache()

  const mutation = useTantalimMutation<LocationNoteDeleteInput, LocationNoteDeleteSuccess>({
    url: '/location/note/delete',
  })

  async function remove(input: LocationNoteDeleteInput): Promise<void> {
    try {
      const { location: newLocation } = await mutation.mutateAsync(input)
      replaceItem(locationId, newLocation)
      await onMutate(locationId, newLocation.locationId)
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationRemove(mutation, remove)
}
